import { ceil, isFunction, map } from 'lodash';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { GridContextProvider, GridDropZone, GridItem, swap, } from 'react-grid-dnd';
import useCurrentUser from '../../../data/hooks/useCurrentUser';
import Strike from '../Strike';
import useLayoutDirection from '../Translations/useLayoutDirection';
import Module from './Module';
import styles from './ModulesGroup.scss';
import useT from '../Translations/useT';
const TWO = 2;
const THREE = 3;
const FOUR = 4;
const SIX = 6;
const HUNDRED = 100;
const BREAKPOINTS = {
    xs: 768,
    sm: 1024,
    md: 1200,
};
export const useScreenSize = () => {
    const [gridCols, setGridCols] = useState(getGridCols(window.innerWidth));
    useEffect(() => {
        const handleResize = () => {
            setGridCols(getGridCols(window.innerWidth));
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return gridCols;
};
const getGridCols = width => {
    if (width <= BREAKPOINTS.xs)
        return TWO;
    if (width <= BREAKPOINTS.sm)
        return THREE;
    if (width <= BREAKPOINTS.md)
        return FOUR;
    return SIX;
};
const ModulesGroup = ({ onClick, accessItems, group, onDragEnd, }) => {
    const t = useT();
    const { isLayoutRTL } = useLayoutDirection();
    const { me } = useCurrentUser();
    const gridCols = useScreenSize();
    const [items, setItems] = useState(group.modules);
    const handleClick = useCallback((module) => onClick(group, module), [
        group,
        onClick,
    ]);
    const modules = useMemo(() => map(items, module => ({
        ...module,
        permission: modulePermission(module, me),
    })), [me, items]);
    function onChange(sourceId, sourceIndex, targetIndex, targetId) {
        const nextState = swap(items, sourceIndex, targetIndex);
        onDragEnd({
            source: { index: sourceIndex },
            destination: { droppableId: group.id, index: targetIndex },
        });
        setItems(nextState);
    }
    if (modules.length > 0) {
        return (<div className={`dropdown modules-list ${styles.rtlGridItemFix}`}>
        <Strike isSubsection title={t(group.title)}/>
        <GridContextProvider onChange={onChange}>
          <GridDropZone boxesPerRow={gridCols} dir={isLayoutRTL ? 'rtl' : 'ltr'} id="modules" rowHeight={120} 
        // eslint-disable-next-line react/forbid-component-props
        style={{
            height: `${ceil(items.length / gridCols) * HUNDRED}px`,
            marginBottom: '40px',
            direction: isLayoutRTL ? 'rtl' : undefined,
        }}>
            {modules.map((module, index) => (<GridItem key={`module-${module.id}`} className="griditemUI">
                <Module key={`module-${module.id}`} accessItems={accessItems} dndIndex={index} module={module} onCLick={handleClick}/>
              </GridItem>))}
          </GridDropZone>
        </GridContextProvider>
      </div>);
    }
    return null;
};
export const modulePermission = (module, currentUser) => isFunction(module.permission)
    ? module.permission(currentUser) && `${module.group}.${module.id}`
    : module.permission;
export default ModulesGroup;
